import React from "react";
export const CardWithImageAndText = ({ text, imgSrc, backgroundColor, linkUrl, linkOpenInNewTab = false, }) => {
    const RootTag = linkUrl ? "a" : "div";
    const href = linkUrl ? linkUrl : undefined;
    const openInNewTabAttr = linkUrl && linkOpenInNewTab ? "_blank" : undefined;
    return (React.createElement(RootTag, { className: "card-with-image-and-text", style: {
            "--background-color": backgroundColor,
        }, href: href, target: openInNewTabAttr },
        React.createElement("img", { src: imgSrc, alt: "" }),
        React.createElement("p", { className: "card-with-image-and-text__text", dangerouslySetInnerHTML: { __html: text } })));
};
